import { render, staticRenderFns } from "./flexbox.vue?vue&type=template&id=555fdf83&scoped=true&"
import script from "./flexbox.vue?vue&type=script&lang=js&"
export * from "./flexbox.vue?vue&type=script&lang=js&"
import style0 from "./flexbox.vue?vue&type=style&index=0&id=555fdf83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555fdf83",
  null
  
)

export default component.exports